// Do not add vue content nor http requests in this file as it is used in ckeditor model plugin
export enum IMediaType {
  Picture = 'picture',
  Document = 'document',
  Video = 'video',
  Sound = 'sound',
  Model3D = '3d_model',
  Sketch = 'sketch',
  Story = 'story',
  Whiteboard = 'whiteboard',
  Simulation = 'simulationMedia',
  AnimatedPicture = 'animatedPicture',
  Drawing = 'drawing',
  HomeByMe = 'homebyme',
}
